import React from 'react';
import { Loader2, Plus, X, Sparkles } from 'lucide-react';

const sel = 'rounded-lg border border-slate-700 bg-slate-950/60 px-2 py-1.5 text-sm text-white focus:border-indigo-400 focus:outline-none';

export const TeamPicker = ({ areas, team, setTeam, motivo, suggesting, onSuggest }) => {
  const options = areas.filter((a) => !a.locked);
  const swap = (i, id) => setTeam(team.map((t, j) => (j === i ? id : t)));
  const free = options.filter((a) => !team.includes(a.id));

  return (
    <div data-testid="team-picker" className="space-y-3 rounded-xl border border-slate-800 bg-slate-950/40 p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-semibold text-white">Socios del equipo</p>
        <button data-testid="team-suggest-btn" onClick={onSuggest} disabled={suggesting}
          className="inline-flex items-center gap-1 rounded-full border border-amber-400/50 px-3 py-1 text-xs font-semibold text-amber-200 hover:bg-amber-500/10 transition-colors disabled:opacity-60">
          {suggesting ? <Loader2 className="h-3 w-3 animate-spin" /> : <Sparkles className="h-3 w-3" />} {team.length ? 'Volver a sugerir' : 'Pedir sugerencia a Cerebro'}
        </button>
      </div>
      {motivo && <p data-testid="team-suggest-motivo" className="text-xs text-slate-400"><span className="text-amber-300">Cerebro sugiere:</span> {motivo}</p>}
      <div className="flex flex-wrap items-center gap-2">
        {team.map((id, i) => (
          <div key={i} className="flex items-center gap-1 rounded-full border border-indigo-400/50 bg-indigo-500/10 py-1 pl-2 pr-1">
            <select data-testid={`team-member-${i}`} value={id} onChange={(e) => swap(i, e.target.value)} className={`${sel} border-0 bg-transparent py-0`}>
              {options.filter((a) => a.id === id || !team.includes(a.id)).map((a) => <option key={a.id} value={a.id} className="bg-slate-900">{a.name}</option>)}
            </select>
            {team.length > 2 && (
              <button data-testid={`team-remove-${i}`} onClick={() => setTeam(team.filter((_, j) => j !== i))} className="rounded-full p-1 text-slate-400 hover:text-red-300"><X className="h-3 w-3" /></button>
            )}
          </div>
        ))}
        {team.length === 2 && free.length > 0 && (
          <select data-testid="team-add-third" value="" onChange={(e) => e.target.value && setTeam([...team, e.target.value])} className={sel}>
            <option value="">+ Agregar tercer socio</option>
            {free.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
        )}
        {team.length === 0 && !suggesting && <p className="text-xs text-slate-500">Pide la sugerencia o elige 2 áreas manualmente.</p>}
      </div>
      {team.length === 0 && (
        <button data-testid="team-manual-btn" onClick={() => setTeam(options.slice(0, 2).map((a) => a.id))} className="inline-flex items-center gap-1 text-xs text-indigo-300 hover:text-indigo-200"><Plus className="h-3 w-3" /> Elegir manualmente</button>
      )}
    </div>
  );
};
